// extracted by mini-css-extract-plugin
export default {"about":"About_about__FeWA2","centerContent":"About_centerContent__9+MIW","para":"About_para__U81B2","content":"About_content__0ZZ0o"};